import { BreachRecord } from '../types';

export const KNOWN_BREACHES: BreachRecord[] = [
  {
    id: 'medibank-2022',
    name: 'Australian Private Healthcare Provider',
    domain: 'medibank.com.au',
    breachDate: '2022-10-12',
    addedDate: '2022-11-01',
    pwnCount: 9700000,
    description: 'In October 2022, a major Australian private health insurer suffered a cyber incident exposing customer names, dates of birth, Medicare numbers, addresses, phone numbers, and sensitive health claims data.',
    dataClasses: ['Names', 'Dates of Birth', 'Medicare Numbers', 'Phone Numbers', 'Email Addresses', 'Health Claims Data', 'Home Addresses'],
    isVerified: true,
    isFabricated: false,
    isSensitive: true,
    isSpamList: false,
    organisation: 'Medibank Private / ahm',
    country: 'Australia'
  },
  {
    id: 'optus-2022',
    name: 'Australian Telecommunications Provider',
    domain: 'optus.com.au',
    breachDate: '2022-09-17',
    addedDate: '2022-09-23',
    pwnCount: 9800000,
    description: 'In September 2022, an unauthorized third party accessed sensitive customer records including driver licence numbers, passport numbers, Medicare numbers, email addresses, and phone numbers.',
    dataClasses: ['Driver Licence Numbers', 'Passport Numbers', 'Medicare Numbers', 'Names', 'Dates of Birth', 'Email Addresses', 'Phone Numbers', 'Physical Addresses'],
    isVerified: true,
    isFabricated: false,
    isSensitive: true,
    isSpamList: false,
    organisation: 'Optus Australia',
    country: 'Australia'
  },
  {
    id: 'latitude-2023',
    name: 'Consumer Finance Provider',
    domain: 'latitudefinancial.com.au',
    breachDate: '2023-03-16',
    addedDate: '2023-03-27',
    pwnCount: 14000000,
    description: 'In March 2023, Latitude Financial disclosed a massive data breach affecting customer records, driver licences, passport numbers, and historical customer financial statements across Australia and New Zealand.',
    dataClasses: ['Driver Licence Numbers', 'Passport Numbers', 'Financial Statements', 'Names', 'Addresses', 'Phone Numbers', 'Income Information'],
    isVerified: true,
    isFabricated: false,
    isSensitive: true,
    isSpamList: false,
    organisation: 'Latitude Financial Services',
    country: 'Australia'
  },
  {
    id: 'ticketmaster-2024',
    name: 'Global Ticketing Platform',
    domain: 'ticketmaster.com',
    breachDate: '2024-05-27',
    addedDate: '2024-06-01',
    pwnCount: 560000000,
    description: 'In May 2024, a threat actor exfiltrated massive datasets from cloud databases containing customer order history, email addresses, phone numbers, and partial credit card payment tokens.',
    dataClasses: ['Email Addresses', 'Names', 'Phone Numbers', 'Billing Addresses', 'Partial Card Details', 'Ticket Purchase History'],
    isVerified: true,
    isFabricated: false,
    isSensitive: false,
    isSpamList: false,
    organisation: 'Ticketmaster / Live Nation',
    country: 'Global / Australia'
  },
  {
    id: 'canva-2019',
    name: 'Australian Design Platform',
    domain: 'canva.com',
    breachDate: '2019-05-24',
    addedDate: '2019-06-02',
    pwnCount: 137000000,
    description: 'In May 2019, Sydney-based graphic design platform Canva suffered a breach resulting in the exposure of user accounts including usernames, email addresses, salted bcrypt password hashes, and geographic locations.',
    dataClasses: ['Email Addresses', 'Usernames', 'Password Hashes (bcrypt)', 'Names', 'Cities / Countries'],
    isVerified: true,
    isFabricated: false,
    isSensitive: false,
    isSpamList: false,
    organisation: 'Canva Pty Ltd',
    country: 'Australia'
  },
  {
    id: 'aus-retail-delivery-2025',
    name: 'National Logistics & Courier Platform',
    domain: 'parcelconnect-au.com',
    breachDate: '2025-08-11',
    addedDate: '2025-08-15',
    pwnCount: 3200000,
    description: 'An insecure cloud bucket belonging to an Australian parcel distribution contractor exposed delivery tracking logs, full names, mobile phone numbers, and delivery street addresses.',
    dataClasses: ['Full Names', 'Mobile Phone Numbers', 'Delivery Addresses', 'Tracking Numbers'],
    isVerified: true,
    isFabricated: false,
    isSensitive: false,
    isSpamList: false,
    organisation: 'National Freight Logistics AU',
    country: 'Australia'
  }
];
